import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { APP_ASSET_VERSION } from './app-asset-version';

const ICON_BASE = 'assets/icons/material/';

/** All Material ligature names registered as SVG (underscore filenames). */
export const MATERIAL_SVG_ICON_NAMES: readonly string[] = [
  'access_time',
  'account_circle',
  'airplanemode_active',
  'arrow_back',
  'autorenew',
  'arrow_drop_down',
  'arrow_drop_up',
  'arrow_forward',
  'attach_file',
  'block',
  'business',
  'cached',
  'calendar_today',
  'call',
  'cancel',
  'check_circle',
  'close',
  'crown',
  'currency_exchange',
  'description',
  'done',
  'download',
  'edit',
  'email',
  'event',
  'expand_more',
  'fmd_good',
  'grade',
  'group_add',
  'help',
  'help_outline',
  'history',
  'keyboard_arrow_down',
  'loading_circle',
  'local_grocery_store',
  'local_offer',
  'local_parking',
  'location_off',
  'location_on',
  'lock',
  'lock_open',
  'login',
  'logout',
  'meeting_room',
  'navigation',
  'near_me',
  'notifications',
  'payment',
  'payments',
  'person',
  'phone',
  'settings',
  'print',
  'priority_high',
  'question_mark',
  'remove',
  'repeat',
  'room',
  'save',
  'schedule',
  'send',
  'shopping_bag',
  'star_half',
  'support_agent',
  'task_alt',
  'toc',
  'traffic',
  'update',
  'view_module',
  'visibility',
  'visibility_off',
  'wifi',
] as const;

export function registerMaterialSvgIcons(
  registry: MatIconRegistry,
  sanitizer: DomSanitizer,
): void {
  for (const name of MATERIAL_SVG_ICON_NAMES) {
    registry.addSvgIcon(
      name,
      sanitizer.bypassSecurityTrustResourceUrl(`${ICON_BASE}${name}.svg?v=${APP_ASSET_VERSION}`),
    );
  }
}
